<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <div v-if="show">
            <GamePopupOne :data-set="dataSet" @close="close" @load-more-game="loadMoreGame" @go-to-deposit="goToDeposit"
                @open-register-popup="openRegisterPopup" @go-to-profile="goToProfile" @go-to-play-game="GoToPlayGame"
                @open="open" @select-group="selectGroup" @on-click-tab="onClickTab" @search-games="searchGames"
                @get-game-tab-data="updateFavoriteGameList" />
        </div>
    </div>

    <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <GamePopupTwo :data-set="dataSet" @close="close" @load-more-game="loadMoreGame" @go-to-deposit="goToDeposit"
            @open-register-popup="openRegisterPopup" @go-to-profile="goToProfile" @go-to-play-game="GoToPlayGame"
            @open="open" @select-group="selectGroup" />

    </div>

    <!-- Theme Three -->
    <div v-if="themeStore.themeIndex === 3">
        <GamePopupThree :data-set="dataSet" @close="close" @load-more-game="loadMoreGame" @go-to-deposit="goToDeposit"
            @open-register-popup="openRegisterPopup" @go-to-profile="goToProfile" @go-to-play-game="GoToPlayGame"
            @open="open" @select-group="selectGroup" @collapse-games="collapseGames" />

    </div>

    <!-- Theme Four -->
    <div v-if="themeStore.themeIndex === 4">
        <GamePopupFour :data-set="dataSet" @close="close" @load-more-game="loadMoreGame" @go-to-deposit="goToDeposit"
            @open-register-popup="openRegisterPopup" @go-to-profile="goToProfile" @go-to-play-game="GoToPlayGame"
            @open="open" @select-group="selectGroup" @on-click-tab="onClickTab" @search-games="searchGames"
            @get-game-tab-data="updateFavoriteGameList" />

    </div>

    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, computed, inject, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { gameListByGroup, groupGames } from '@/api/game'
import { playClickSound } from "@/utils/media";
import StatusPopup from '@/components/common/statusPopup.vue'
import { useGameStore } from '@/stores/games'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useUserStore } from '@/stores/user'
import GamePopupOne from '@/themes/themeOne/game/gamePopup.vue';
import GamePopupTwo from '@/themes/themeTwo/game/gamePopup.vue';
import GamePopupThree from '@/themes/themeThree/game/gamePopup.vue';
import GamePopupFour from '@/themes/themeFour/game/gamePopup.vue';
import { GameData, GameItem, getGameListByGroup, PAGE_SIZE } from './supportScript';
import { useThemeStore } from '@/stores/theme';
import { fetchGameList } from '../home/supportScript';

const router = useRouter()
const gameStore = useGameStore()
const userStore = useUserStore()
const themeStore = useThemeStore()

const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const pageNumber = ref(1)
const active = ref(0);
const show = ref(false)
const gameCount = ref(0)
const loadedGameCount = ref(0)
const showLoadMore = ref(true)
const showPopover = ref(false);
const groupList = computed(() =>
    themeStore.themeIndex == 1 || themeStore.themeIndex == 4 ?
        gameStore.initialGroupList.map((item: any) => ({
            id: item.id,
            icon: item.customIcon,
            name: item.name,
            groupType: item.groupType
        })) :

        gameStore.groupList.map((item: any) => ({
            id: item.id,
            icon: item.customIcon,
            name: item.name,
            groupType: item.groupType
        }))
)
const activeItem = ref(groupList.value[0] ? groupList.value[0].id : 0)
const gameList = ref<GameItem[]>([])
const favoriteGameList = computed(() => gameStore.groupList[1].games)
const loading = ref(false)
const groupID = ref()
const groupType = ref('')
const balance = computed(() => userStore.balance)
const mainHeader = ref<{ url: string; display: boolean }>({ url: '', display: true })
const depositButon = ref({
    colorCode: '',
    display: false,
    redirectUrl: ''
})
const profileButtonData = ref({
    url: '',
    display: false,
    redirectUrl: ''
})
const searchData = ref('')
const isShowSearchGames = ref()
const dataSet = computed<GameData>(() => ({
    active: active.value,
    show: show.value,
    showLoadMore: showLoadMore.value,
    showPopover: showPopover.value,
    groupList: groupList.value,
    activeItem: activeItem.value,
    gameList: gameList.value,
    loading: loading.value,
    balance: balance.value,
    mainHeader: mainHeader.value,
    depositButon: depositButon.value,
    profileButtonData: profileButtonData.value,
    gameCount: gameCount.value
}))

const emits = defineEmits(['resetSelectedGroup', 'goToProfile'])
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')

const open = (data: any) => {
    const URL = localStorage.getItem('componetList')

    if (URL) {
        try {
            const componentList = JSON.parse(URL)
            const headerComponent = componentList.find(
                (item: any) => item.component_name === 'header'
            )
            mainHeader.value = headerComponent.appIcon
            depositButon.value = headerComponent.depositButton
            profileButtonData.value = headerComponent.profileButton
        } catch (error) {
            console.error("Failed to parse componetList from localStorage", error)
        }
    }
    loadingRef.value.open()
    show.value = true
    groupID.value = data.id
    groupType.value = data.groupType
    activeItem.value = data.id
    if (data.id == 'fav') {
        gameList.value = favoriteGameList.value
        gameCount.value = gameList.value.length
        showLoadMore.value = false
        loadingRef.value.close()
    } else {
        if (themeStore.themeIndex == 4 || themeStore.themeIndex == 1) {
            getGameList()
        } else {
            getGameGroupList()
        }
    }

}

const close = () => {
    show.value = false
    gameList.value = []
    pageNumber.value = 1
    gameStore.getGameGroupListData()
    loadedGameCount.value = 0;
    active.value = 0
    emits('resetSelectedGroup')
}
const goToProfile = () => {
    emits('goToProfile')
}
const selectGroup = (item: any) => {
    loadingRef.value.open()
    groupID.value = item.id
    groupType.value = item.groupType
    gameList.value = [];
    activeItem.value = item.id
    pageNumber.value = 1
    loadedGameCount.value = 0
    if (item.id == 'fav') {
        gameList.value = favoriteGameList.value
        gameCount.value = gameList.value.length
        loadingRef.value.close()
    } else {
        if (themeStore.themeIndex == 4 || themeStore.themeIndex == 1) {
            getGameList()
        } else {
            getGameGroupList()
        }
    }
    showPopover.value = false
}
const loadMoreGame = () => {
    loading.value = true
    pageNumber.value++
    if (loadedGameCount.value < gameCount.value) {
        if (themeStore.themeIndex == 4) {
            if (isShowSearchGames.value) {
                getSearchGameList()
            } else {
                getGameList()
            }
        } else {
            getGameGroupList()
        }
    }
}
const collapseGames = () => {
    loadedGameCount.value = PAGE_SIZE
    pageNumber.value = 1
    loading.value = true
    gameList.value = gameList.value.slice(0, PAGE_SIZE)
    showLoadMore.value = true
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getGameGroupList = () => {
    let params = {
        pageNum: pageNumber.value,
        pageSize: PAGE_SIZE,
        groupId: groupID.value,
        groupType: groupType.value
    }
    groupGames(params).then(res => {
        loadingRef.value.close()
        let resData = res.data
        gameCount.value = resData.total
        loadedGameCount.value = loadedGameCount.value + PAGE_SIZE
        loading.value = false
        gameList.value = [...gameList.value, ...resData.rows];
        if (gameCount.value <= loadedGameCount.value) {
            showLoadMore.value = false
        } else {
            showLoadMore.value = true
        }
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const openRegisterPopup = (type: number) => {
    openRegisterLoginPopup?.(type)
}
const goToDeposit = () => {
    playClickSound()
    router.push(depositButon.value.redirectUrl)
}
const GoToPlayGame = (data: any) => {
    let token = localStorage.getItem('token')
    if (token) {
        router.push({ path: '/pgame', query: { game_type: data.id, game_maker: data.makerId, favorite: data.isFavorite, fav_id: data.favId } })
    } else {
        openRegisterPopup(1)
    }
}
const onClickTab = (value: any) => {
    isShowSearchGames.value = false
    active.value = value.name;
    loadingRef.value.open();
    gameList.value = [];
    pageNumber.value = 1;
    loadedGameCount.value = 0;
    getGameList();
}

const getGameList = () => {
    let params = {
        pageNum: pageNumber.value,
        pageSize: PAGE_SIZE,
        groupId: groupID.value,
        type: active.value
    }
    gameListByGroup(params).then(res => {
        loadingRef.value.close()
        if (res.data) {
            let resData = res.data
            gameCount.value = resData?.total || 0
            loadedGameCount.value = loadedGameCount.value + PAGE_SIZE
            loading.value = false
            gameList.value = [...gameList.value, ...resData.rows];
            if (gameCount.value <= loadedGameCount.value) {
                showLoadMore.value = false
            } else {
                showLoadMore.value = true
            }
        } else {
            gameList.value = []
            loadedGameCount.value = 0
            gameCount.value = 0
        }

    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const searchGames = (data: string) => {
    isShowSearchGames.value = true
    searchData.value = data
    active.value = 0;
    resetList()
    getSearchGameList();
};
const getSearchGameList = async () => {
    loading.value = true
    loadingRef.value.open()
    const { rows, total } = await fetchGameList(pageNumber.value, PAGE_SIZE, searchData.value, groupID.value) // group id should be pass to group serach

    loading.value = false
    loadingRef.value.close()
    gameList.value = [...gameList.value, ...rows]
    gameCount.value = total
    showLoadMore.value = total > pageNumber.value * PAGE_SIZE
}
const resetList = () => {
    pageNumber.value = 1;
    gameList.value = [];
};
const updateFavoriteGameList = () => {
    loadingRef.value.open()
    gameList.value = [];
    getGameList()
}
defineExpose({
    open,
    selectGroup,
})


</script>